import DraggerUpload from './ui/dragger';
import Card from './ui/card';

export const Slides = {
  DraggerUpload,
  Card,
};
